import { Descriptions, Divider, Drawer, type DrawerProps } from 'antd';
import useFlow from '@app/hooks/flows/useFlow';

type FlowDrawerProps = DrawerProps & {
    name: string;
    id: string;
};

const FlowDrawer = ({ name, id, ...props }: FlowDrawerProps) => {
    const { isLoading, data: flowData } = useFlow({ id: id });

    return (
        <Drawer
            className="flow-detail-drawer"
            title={
                <>
                    <span>{name}</span>
                    <div className="ant-drawer-header-meta">
                        <span>ID: {id}</span>
                    </div>
                </>
            }
            size={700}
            closable={{ 'aria-label': 'Close Button' }}
            {...props}>
            {flowData?.assigned_agents
                ? flowData?.assigned_agents?.map((agent, index) => (
                      <>
                          <Descriptions
                              title={index === 0 ? 'Agents Assigned Flow' : ''}
                              colon={false}
                              layout="vertical"
                              items={[
                                  { key: 'name', label: 'Name', children: agent.name },
                                  { key: 'id', label: 'ID', children: agent.id },
                                  {
                                      key: 'numbers',
                                      label: 'Numbers',
                                      children: (
                                          <div className="margin-left-20">
                                              {agent.numbers.map((num) => (
                                                  <Descriptions
                                                      key={num.number_id}
                                                      colon={false}
                                                      layout="vertical"
                                                      items={[
                                                          {
                                                              key: 'number',
                                                              label: 'Number',
                                                              children: num.number,
                                                          },
                                                          {
                                                              key: 'number_id',
                                                              label: 'Number ID',
                                                              children: num.number_id,
                                                          },
                                                          {
                                                              key: 'Location',
                                                              label: 'Location',
                                                              children: num.location,
                                                          },
                                                          {
                                                              key: 'location_id',
                                                              label: 'Location ID',
                                                              children: num.location_id,
                                                          },
                                                      ]}
                                                      column={2}
                                                  />
                                              ))}
                                          </div>
                                      ),
                                  },
                              ]}
                              column={2}
                          />
                          {index !== (flowData.assigned_agents?.length ?? 0) - 1 && <Divider />}
                      </>
                  ))
                : !isLoading && (
                      <div className="no-agents-assigned">
                          <div>Agents Assigned Flow</div>
                          <div>Currently not assigned to any Agents</div>
                      </div>
                  )}
        </Drawer>
    );
};

export default FlowDrawer;
